import type {
  Condition,
  ZeroEtlIdentityColumnSpec,
  ZeroEtlRoutingMode,
} from '@repo/api-gw-sdk';

import type { ResourcesScopeType } from '@/components/resourcesSelection/resourceSelectionDynamicViewer';
import type { Step } from '@/components/wizard/Step';

import { ZeroEtlPolicyCatalogSelection } from './ZeroEtlPolicyCatalogSelection';
import { ZeroEtlPolicyConditionEditor } from './ZeroEtlPolicyConditionEditor';
import { ZeroEtlPolicyNameSelection } from './ZeroEtlPolicyNameSelection';
import { ZeroEtlPolicyResourcesList } from './ZeroEtlPolicyResourcesList';

export const FULLY_QUALIFIED_NAMESPACE =
  '{source_cloud}.{source_account_id}.{source_region}.{resource_id}.{database_name}.{schema_name}';
export const FULLY_QUALIFIED_TABLE = '{table_name}';

export interface ZeroEtlPolicyEditState {
  id: string;
  name: string;
  workspaceId: string;
  condition?: Condition;
  focusOnName: boolean;
  include: string[];
  exclude: string[];
  resourcesScopeType: ResourcesScopeType;
  catalogIds: string[];
  routingMode: ZeroEtlRoutingMode;
  namespaceTemplate: string;
  tableTemplate: string;
  identityColumns: ZeroEtlIdentityColumnSpec[];
}

export const EditZeroEtlPolicyFlow: Step<ZeroEtlPolicyEditState> = {
  id: 'name_selection',
  Component: ZeroEtlPolicyNameSelection,
  nonReturnable: true,
  next: [
    {
      id: 'resource_selection',
      Component: ZeroEtlPolicyConditionEditor,
      next: [
        {
          id: 'resource_list',
          Component: ZeroEtlPolicyResourcesList,
          next: [
            {
              id: 'catalog_selection',
              Component: ZeroEtlPolicyCatalogSelection,
            },
          ],
        },
      ],
    },
  ],
};
